import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    aniUsersList: [],
    pageCount: 0, 
    loaderForButton: false,  
    dataLoader: false, 
    size: 0, 
    total: 0, 
    userBasedTabs: 'user-details',
    selectedUsers: [],
    deSelectedUsers: [],
    isSelectedAllUsers: false,
    scrollPosition: 0,
}

const certifiedUserSlice = createSlice({
    name: "certifiedUser",
    initialState,
    reducers: {
        setAniUsersList(state, action) {
            state.aniUsersList = action.payload.pagination ? [...state.aniUsersList, ...action.payload.aniUsersList] : action.payload?.aniUsersList
            state.pageCount = action.payload.pageCount || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.dataLoader = action.payload?.dataLoader || false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setUsersLoaderForButton(state, action) {
            state.loaderForButton = action?.payload
        },
        setUsersLoader(state, action) {
            state.dataLoader = action?.payload
        },
        clearSelectedUser(state, action) {
            state.selectedUsers = []
        },
        setSelectedUser(state, action) {
            state.selectedUsers = [...state.selectedUsers, action.payload]
        },
        setDeselectedUser(state, action) {
            state.selectedUsers = state.selectedUsers.filter(
                (item) => !(item?.creatorId === action.payload?.creatorId))
        },
        selectAllUsers(state, action) {
            state.selectedUsers = action.payload;
        },
        clearAniUsersList(action, state) {
            return initialState
        },
        defaultState(state, action) {
            return initialState
        },
        setUserStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    },
})

export const { setUsersLoader, setUsersLoaderForButton, setAniUsersList, setUserStates, 
             clearAniUsersList, setSelectedUser, setDeselectedUser,  selectAllUsers} = certifiedUserSlice.actions

export const certifiedUserActions = certifiedUserSlice.actions;

export default certifiedUserSlice;
